import {ProductType} from '@mintdata-wsp/common/state/StorefrontState';

export abstract class ProductGrant
{
    constructor(public productType:ProductType)
    {}
}

export class CloudAccessGrant extends ProductGrant
{
    constructor(public maxApplications:number,
                public maxUsers:number)
    {
        super(ProductType.Cloud_Access);
    }
}

export class AddonType
{
    public static readonly CustomDomain = new AddonType('custom-domain');
    public static readonly CloudComponents = new AddonType('cloud-components');

    private _value:string;

    constructor(value:string)
    {
        this._value = value;
    }

    public static parseFrom(str:string):AddonType
    {
        if( str === AddonType.CustomDomain._value )
            return AddonType.CustomDomain;
        else if( str === AddonType.CloudComponents._value )
            return AddonType.CloudComponents;
        else
            return null;
    }
}

export class AddonGrant extends ProductGrant
{
    constructor(public addonType:AddonType)
    {
        super(ProductType.Addon);
    }
}

export class CustomDomainGrant extends AddonGrant
{
    constructor()
    {
        super(AddonType.CustomDomain);
    }
}

export class CloudComponentsGrant extends AddonGrant
{
    constructor(public mavenGroup:string,
                public mavenArtifactId:string)
    {
        super(AddonType.CloudComponents);
    }
}

export class ProductGrantParser
{
    public static parseFromString(productGrantStr:string):ProductGrant
    {
        let productGrant = null;

        try
        {
            productGrant = JSON.parse(productGrantStr);
        }
        catch (e)
        {
            return null;
        }

        let addon = productGrant.addon;

        if( addon )
        {
            const addonType: AddonType = AddonType.parseFrom(addon.type);
            if (!addonType)
                return null;

            if (addonType === AddonType.CustomDomain)
                return new CustomDomainGrant();
            else if (addonType === AddonType.CloudComponents)
            {
                if( !addon.group || !addon.artifactId )
                    return null;

                return new CloudComponentsGrant(addon.group, addon.artifactId);
            }
            else
                return null;
        }
        else
        {
            const maxApplications = productGrant.maxApplications;
            const maxUsers = productGrant.maxUsers;

            if( !maxApplications || !maxUsers )
                return null;

            return new CloudAccessGrant(maxApplications, maxUsers);
        }
    }
}


// { "addon" : { "type" : "cloud-components", "group" : "mintdata", "artifactId" : "webcrawler-components" } }
